module.exports = __webpack_public_path__ + "static/media/lincoln-checkmark.8a3ddb16.svg";